module.exports = __webpack_public_path__ + "static/media/logo-tava-mob.fac49122.jpg";